var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "pa-0 background darken-1", attrs: { fluid: "" } },
    [
      _c(
        "v-container",
        {
          staticClass: "pa-2 background darken-1",
          attrs: { "grid-list-xs": "" }
        },
        [
          _c(
            "v-layout",
            [
              _c(
                "v-flex",
                { attrs: { shrink: "" } },
                [
                  _c("v-text-field", {
                    staticClass: "mb-3 grv-input mr-1",
                    staticStyle: { width: "300px" },
                    attrs: {
                      solo: "",
                      name: "OF",
                      rules: [],
                      loading: _vm.loading_of,
                      type: "number",
                      clearable: "",
                      messages: [_vm.input_message]
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "prepend-inner",
                        fn: function() {
                          return [_vm._v("\n\t\t\t\t\t\tOF\n\t\t\t\t\t")]
                        },
                        proxy: true
                      },
                      {
                        key: "append",
                        fn: function() {
                          return [
                            _c(
                              "v-btn",
                              {
                                staticClass: "mx-0",
                                attrs: {
                                  flat: "",
                                  icon: "",
                                  color: "primary",
                                  disabled: !_vm.num_of
                                },
                                on: {
                                  click: function($event) {
                                    _vm.num_of--
                                  }
                                }
                              },
                              [_c("v-icon", [_vm._v("chevron_left")])],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-btn",
                              {
                                staticClass: "mx-0",
                                attrs: {
                                  flat: "",
                                  icon: "",
                                  color: "primary",
                                  disabled: !_vm.num_of
                                },
                                on: {
                                  click: function($event) {
                                    _vm.num_of++
                                  }
                                }
                              },
                              [_c("v-icon", [_vm._v("chevron_right")])],
                              1
                            )
                          ]
                        },
                        proxy: true
                      }
                    ]),
                    model: {
                      value: _vm.num_of,
                      callback: function($$v) {
                        _vm.num_of = _vm._n($$v)
                      },
                      expression: "num_of"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.computed_data
            ? _c(
                "div",
                [
                  _c("div", { staticClass: "mb-4" }, [
                    _c(
                      "div",
                      {
                        staticClass: "mb-1",
                        staticStyle: {
                          display: "flex",
                          "align-items": "center"
                        }
                      },
                      [
                        _c("span", { staticClass: "headline" }, [
                          _vm._v(
                            "\n\t\t\t\t\t\tCOMMANDE\n\t\t\t\t\t\t" +
                              _vm._s(_vm.computed_data.commande.id) +
                              "\n\t\t\t\t\t"
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "v-chip",
                          {
                            staticClass: "my-0 mx-2",
                            attrs: { small: "", outline: "", color: "white" }
                          },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t\t" +
                                _vm._s(_vm.computed_data.commande.status) +
                                "\n\t\t\t\t\t"
                            )
                          ]
                        ),
                        _vm._v(
                          "\n\t\t\t\t\tCréé le " +
                            _vm._s(
                              _vm._f("formatDateNoTime")(
                                _vm.computed_data.creation_date
                              )
                            ) +
                            "\n\t\t\t\t"
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v("\n\t\t\t\t\tSuivi par\n\t\t\t\t\t"),
                      _c("span", { staticClass: "subheading" }, [
                        _vm._v(
                          "\n\t\t\t\t\t\t" +
                            _vm._s(_vm.computed_data.cdc.login) +
                            "\n\t\t\t\t\t"
                        )
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "caption" }, [
                        _vm._v(
                          "\n\t\t\t\t\t\t(" +
                            _vm._s(
                              _vm._f("capitalize")(_vm.computed_data.cdc.name)
                            ) +
                            ")\n\t\t\t\t\t"
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v("\n\t\t\t\t\tClient:\n\t\t\t\t\t"),
                      _c("span", { staticClass: "subheading" }, [
                        _vm._v(
                          "\n\t\t\t\t\t\t" +
                            _vm._s(_vm.computed_data.customer) +
                            "\n\t\t\t\t\t"
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "mb-4" }, [
                    _c(
                      "div",
                      {
                        staticClass: "mb-1",
                        staticStyle: {
                          display: "flex",
                          "align-items": "center"
                        }
                      },
                      [
                        _c("span", { staticClass: "headline" }, [
                          _vm._v(
                            "\n\t\t\t\t\t\tOF\n\t\t\t\t\t\t" +
                              _vm._s(_vm.computed_data.of.id) +
                              "\n\t\t\t\t\t"
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "v-chip",
                          {
                            staticClass: "my-0 mx-2",
                            attrs: { small: "", outline: "", color: "white" }
                          },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t\t" +
                                _vm._s(_vm.computed_data.of.status) +
                                "\n\t\t\t\t\t"
                            )
                          ]
                        ),
                        _vm._v(
                          "\n\t\t\t\t\tDélai: " +
                            _vm._s(
                              _vm._f("formatDateNoTime")(
                                _vm.computed_data.due_date
                              )
                            ) +
                            "\n\t\t\t\t"
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "subheading" }, [
                      _vm._v(
                        "\n\t\t\t\t\t" +
                          _vm._s(_vm.computed_data.title.princ) +
                          "\n\t\t\t\t\t"
                      ),
                      _c(
                        "a",
                        {
                          staticClass: "ml-2",
                          attrs: {
                            href:
                              _vm.behive_url +
                              "dashboard/title/" +
                              _vm.computed_data.title.id +
                              "/",
                            target: "_blank"
                          }
                        },
                        [_vm._v("\n\t\t\t\t\t\tBeHive\n\t\t\t\t\t")]
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "subheading background--text text--lighten-5"
                      },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t" +
                            _vm._s(_vm.computed_data.title.sec) +
                            "\n\t\t\t\t"
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-layout",
                    [
                      _c(
                        "v-flex",
                        { staticClass: "pr-1", attrs: { xs6: "" } },
                        [
                          _c("div", { staticClass: "headline mb-1" }, [
                            _vm._v("\n\t\t\t\t\t\tASSETS\n\t\t\t\t\t")
                          ]),
                          _vm._v(" "),
                          !_vm.is_detail_page && _vm.selected_fab
                            ? _c(
                                "v-btn",
                                {
                                  staticClass: "text-none",
                                  attrs: { block: "", color: "blue" },
                                  on: {
                                    click: function($event) {
                                      return _vm.emitAssets()
                                    }
                                  }
                                },
                                [
                                  _c("v-icon", { staticClass: "mr-2" }, [
                                    _vm._v("subscriptions")
                                  ]),
                                  _vm._v(
                                    "\n\t\t\t\t\t\tUtiliser les assets sources\n\t\t\t\t\t"
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "v-expansion-panel",
                            {
                              staticClass: "assets-panels",
                              attrs: { expand: "" }
                            },
                            [
                              _c("v-expansion-panel-content"),
                              _vm._v(" "),
                              _vm._l(_vm.computed_data.assets, function(
                                asset,
                                asset_id
                              ) {
                                return _c(
                                  "v-expansion-panel-content",
                                  {
                                    key: asset_id,
                                    staticClass: "asset-panel elevation-4",
                                    class: _vm.computeAssetIOClass(asset)
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "expansion-header-dynamic",
                                        attrs: { slot: "header" },
                                        slot: "header"
                                      },
                                      [
                                        _vm.selected_fab
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "dynamic-col",
                                                style: {
                                                  "min-width": "50px",
                                                  "max-width": "50px"
                                                }
                                              },
                                              [
                                                asset.source_of_fab.indexOf(
                                                  _vm.selected_fab
                                                ) > -1
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "ml-1 blue--text"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n\t\t\t\t\t\t\t\t\t\tSRC\n\t\t\t\t\t\t\t\t\t"
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                asset.record_of_fab.indexOf(
                                                  _vm.selected_fab
                                                ) > -1
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "ml-1 green--text text--accent-3"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n\t\t\t\t\t\t\t\t\t\tREC\n\t\t\t\t\t\t\t\t\t"
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "dynamic-col",
                                            style: {
                                              "min-width":
                                                _vm.asset_col_widths.type_sup +
                                                "px",
                                              "max-width":
                                                _vm.asset_col_widths.type_sup +
                                                "px"
                                            }
                                          },
                                          [
                                            _c(
                                              "v-tooltip",
                                              {
                                                attrs: {
                                                  bottom: "",
                                                  color: "background"
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "activator",
                                                      fn: function(ref) {
                                                        var on = ref.on
                                                        return [
                                                          _c(
                                                            "span",
                                                            _vm._g({}, on),
                                                            [
                                                              _vm._v(
                                                                "\n\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                  _vm._s(
                                                                    asset
                                                                      .type_sup
                                                                      .code
                                                                  ) +
                                                                  "\n\t\t\t\t\t\t\t\t\t\t\t"
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      }
                                                    }
                                                  ],
                                                  null,
                                                  true
                                                )
                                              },
                                              [
                                                _vm._v(" "),
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(asset.type_sup.label)
                                                  )
                                                ])
                                              ]
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "dynamic-col",
                                            style: {
                                              "min-width": "88px",
                                              "max-width": "88px"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t\t" +
                                                _vm._s(asset.ref_materiel) +
                                                "\n\t\t\t\t\t\t\t\t"
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "dynamic-col",
                                            style: {
                                              "min-width":
                                                _vm.asset_col_widths.norme +
                                                "px",
                                              "max-width":
                                                _vm.asset_col_widths.norme +
                                                "px"
                                            }
                                          },
                                          [
                                            _c(
                                              "v-tooltip",
                                              {
                                                attrs: {
                                                  bottom: "",
                                                  color: "background"
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "activator",
                                                      fn: function(ref) {
                                                        var on = ref.on
                                                        return [
                                                          _c(
                                                            "span",
                                                            _vm._g({}, on),
                                                            [
                                                              _vm._v(
                                                                "\n\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                  _vm._s(
                                                                    asset.norme
                                                                      .code
                                                                  ) +
                                                                  "\n\t\t\t\t\t\t\t\t\t\t\t"
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      }
                                                    }
                                                  ],
                                                  null,
                                                  true
                                                )
                                              },
                                              [
                                                _vm._v(" "),
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(asset.norme.label)
                                                  )
                                                ])
                                              ]
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "dynamic-col",
                                            style: {
                                              "min-width": "76px",
                                              "max-width": "76px"
                                            }
                                          },
                                          [
                                            asset.master
                                              ? _c(
                                                  "span",
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        attrs: {
                                                          size: 20,
                                                          color:
                                                            "green accent-3"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n\t\t\t\t\t\t\t\t\t\t\tcheck\n\t\t\t\t\t\t\t\t\t\t"
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "caption green--text text--accent-3",
                                                        staticStyle: {
                                                          top: "-1px",
                                                          left: "-2px",
                                                          position: "relative"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n\t\t\t\t\t\t\t\t\t\t\tMaster\n\t\t\t\t\t\t\t\t\t\t"
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                )
                                              : _vm._e()
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "dynamic-col text-right",
                                            style: {
                                              "min-width":
                                                _vm.asset_col_widths.size +
                                                "px",
                                              "max-width":
                                                _vm.asset_col_widths.size + "px"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t\t" +
                                                _vm._s(
                                                  _vm._f("humanizeBytes1000")(
                                                    asset.size
                                                  )
                                                ) +
                                                "\n\t\t\t\t\t\t\t\t"
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "dynamic-col",
                                            style: { width: "max-content" }
                                          },
                                          _vm._l(asset.asset_resume, function(
                                            item,
                                            index
                                          ) {
                                            return _c(
                                              "span",
                                              {
                                                key: "resume" + index,
                                                staticClass: "resume-item"
                                              },
                                              [
                                                _vm._v(
                                                  "\n\t\t\t\t\t\t\t\t\t\t" +
                                                    _vm._s(item) +
                                                    "\n\t\t\t\t\t\t\t\t\t"
                                                )
                                              ]
                                            )
                                          }),
                                          0
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-card",
                                      { staticClass: "background darken-1" },
                                      [
                                        _c(
                                          "v-card-text",
                                          { staticClass: "px-2 pb-1 pt-0" },
                                          [
                                            asset.filepath
                                              ? _c("div", [
                                                  asset.filepath.indexOf(
                                                    "/"
                                                  ) === 0
                                                    ? _c(
                                                        "span",
                                                        [
                                                          _c(
                                                            "router-link",
                                                            {
                                                              attrs: {
                                                                target:
                                                                  "_blank",
                                                                to: {
                                                                  name:
                                                                    "Filesystem",
                                                                  query: {
                                                                    path: _vm.maestroToUNC(
                                                                      asset.filepath
                                                                    )
                                                                  }
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                  _vm._s(
                                                                    _vm.maestroToUNC(
                                                                      asset.filepath
                                                                    )
                                                                  ) +
                                                                  "\n\t\t\t\t\t\t\t\t\t\t\t"
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    : _c("span", [
                                                        _vm._v(
                                                          _vm._s(asset.filepath)
                                                        )
                                                      ])
                                                ])
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c("div", [
                                              _c(
                                                "a",
                                                {
                                                  attrs: {
                                                    href:
                                                      _vm.behive_url +
                                                      "dashboard/materials/" +
                                                      asset_id +
                                                      "/",
                                                    target: "_blank"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n\t\t\t\t\t\t\t\t\t\t\tBeHive\n\t\t\t\t\t\t\t\t\t\t"
                                                  )
                                                ]
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "subheading",
                                                class: {
                                                  "warning--text":
                                                    _vm.computed_data.title.princ.toLowerCase() !==
                                                    asset.titre.princ.toLowerCase()
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n\t\t\t\t\t\t\t\t\t\t" +
                                                    _vm._s(asset.titre.princ) +
                                                    "\n\t\t\t\t\t\t\t\t\t"
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "background--text text--lighten-5 pb-2",
                                                class: {
                                                  "warning--text text--lighten-2":
                                                    _vm.computed_data.title.princ.toLowerCase() !==
                                                    asset.titre.princ.toLowerCase()
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n\t\t\t\t\t\t\t\t\t\t" +
                                                    _vm._s(asset.titre.sec) +
                                                    "\n\t\t\t\t\t\t\t\t\t"
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("table", [
                                              _c("tbody", [
                                                asset.duration
                                                  ? _c("tr", [
                                                      _c("td", [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "mr-3 background--text text--lighten-5"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tDurée\n\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                            )
                                                          ]
                                                        )
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("td", [
                                                        _vm._v(
                                                          "\n\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                            _vm._s(
                                                              asset.duration
                                                            ) +
                                                            "\n\t\t\t\t\t\t\t\t\t\t\t\t"
                                                        )
                                                      ])
                                                    ])
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                asset.codec ||
                                                asset.fmt_film ||
                                                asset.profile ||
                                                asset.fps ||
                                                asset.resolution
                                                  ? _c("tr", [
                                                      _c("td", [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "mr-3 background--text text--lighten-5"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tImage\n\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                            )
                                                          ]
                                                        )
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("td", [
                                                        asset.codec
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "mr-2"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                    _vm._s(
                                                                      asset.codec
                                                                    ) +
                                                                    "\n\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                )
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        asset.fmt_film
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "mr-2"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                    _vm._s(
                                                                      asset.fmt_film
                                                                    ) +
                                                                    "\n\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                )
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        asset.profile
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "mr-2"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                    _vm._s(
                                                                      asset.profile
                                                                    ) +
                                                                    "\n\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                )
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        asset.fps
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "mr-2"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                    _vm._s(
                                                                      asset.fps
                                                                    ) +
                                                                    "fps\n\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                )
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        asset.resolution
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "mr-2"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                    _vm._s(
                                                                      asset.resolution
                                                                    ) +
                                                                    "\n\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                )
                                                              ]
                                                            )
                                                          : _vm._e()
                                                      ])
                                                    ])
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                asset.audio.length
                                                  ? _c("tr", [
                                                      _c("td", [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "mr-3 background--text text--lighten-5"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tSon\n\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                            )
                                                          ]
                                                        )
                                                      ]),
                                                      _vm._v(" "),
                                                      _c(
                                                        "td",
                                                        _vm._l(
                                                          asset.audio,
                                                          function(
                                                            audio,
                                                            index
                                                          ) {
                                                            return _c(
                                                              "span",
                                                              {
                                                                key:
                                                                  "audio" +
                                                                  index,
                                                                staticClass:
                                                                  "mr-2"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                    _vm._s(
                                                                      audio
                                                                    ) +
                                                                    "\n\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                )
                                                              ]
                                                            )
                                                          }
                                                        ),
                                                        0
                                                      )
                                                    ])
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                asset.subtitle.length
                                                  ? _c("tr", [
                                                      _c("td", [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "mr-3 background--text text--lighten-5"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tSous-titres\n\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                            )
                                                          ]
                                                        )
                                                      ]),
                                                      _vm._v(" "),
                                                      _c(
                                                        "td",
                                                        _vm._l(
                                                          asset.subtitle,
                                                          function(
                                                            subtitle,
                                                            index
                                                          ) {
                                                            return _c(
                                                              "span",
                                                              {
                                                                key:
                                                                  "subtitle" +
                                                                  index,
                                                                staticClass:
                                                                  "mr-2"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                    _vm._s(
                                                                      subtitle
                                                                    ) +
                                                                    "\n\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                )
                                                              ]
                                                            )
                                                          }
                                                        ),
                                                        0
                                                      )
                                                    ])
                                                  : _vm._e()
                                              ])
                                            ])
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              })
                            ],
                            2
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { staticClass: "pl-1", attrs: { xs6: "" } },
                        [
                          _c("div", { staticClass: "headline mb-1" }, [
                            _vm._v("\n\t\t\t\t\t\tFABRICATIONS\n\t\t\t\t\t")
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.computed_data.fabrications, function(fab) {
                            return _c(
                              "div",
                              {
                                key: fab.idÒ,
                                staticClass: "mb-2 pa-2 suifa-fab elevation-4",
                                class: {
                                  "selected-fab": _vm.selected_fab === fab.id
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.toggleFab(fab)
                                  }
                                }
                              },
                              [
                                _c(
                                  "v-container",
                                  { staticClass: "pa-0", attrs: { fluid: "" } },
                                  [
                                    _c(
                                      "v-layout",
                                      [
                                        _c("v-flex", { attrs: { grow: "" } }, [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "title d-inline-block text-center",
                                              staticStyle: {
                                                "min-width": "28px",
                                                "max-width": "28px"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n\t\t\t\t\t\t\t\t\t\t" +
                                                  _vm._s(fab.id) +
                                                  "\n\t\t\t\t\t\t\t\t\t"
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "subheading" },
                                            [
                                              _vm._v(
                                                "\n\t\t\t\t\t\t\t\t\t\t" +
                                                  _vm._s(fab.prestation.code) +
                                                  "\n\t\t\t\t\t\t\t\t\t"
                                              )
                                            ]
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "v-flex",
                                          { attrs: { shrink: "" } },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "background--text text--lighten-5"
                                              },
                                              [
                                                _vm._v(
                                                  "\n\t\t\t\t\t\t\t\t\t\tdélai:\n\t\t\t\t\t\t\t\t\t"
                                                )
                                              ]
                                            ),
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t\t" +
                                                _vm._s(
                                                  _vm._f("formatDateNoTime")(
                                                    fab.due_date
                                                  )
                                                ) +
                                                "\n\t\t\t\t\t\t\t\t"
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-layout",
                                      { staticClass: "pb-2 offset-right" },
                                      [
                                        _c("v-flex", { attrs: { xs12: "" } }, [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "background--text text--lighten-5"
                                            },
                                            [
                                              _vm._v(
                                                "\n\t\t\t\t\t\t\t\t\t\t" +
                                                  _vm._s(fab.prestation.label) +
                                                  "\n\t\t\t\t\t\t\t\t\t"
                                              )
                                            ]
                                          )
                                        ])
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-layout",
                                      { staticClass: "offset-right" },
                                      [
                                        _c(
                                          "v-flex",
                                          { attrs: { shrink: "" } },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "background--text text--lighten-5"
                                              },
                                              [
                                                _vm._v(
                                                  "\n\t\t\t\t\t\t\t\t\t\tZone:\n\t\t\t\t\t\t\t\t\t"
                                                )
                                              ]
                                            ),
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t\t" +
                                                _vm._s(fab.zone_fab) +
                                                "\n\t\t\t\t\t\t\t\t"
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-layout",
                                      { staticClass: "offset-right" },
                                      [
                                        _c(
                                          "v-flex",
                                          { attrs: { shrink: "" } },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "background--text text--lighten-5"
                                              },
                                              [
                                                _vm._v(
                                                  "\n\t\t\t\t\t\t\t\t\t\tStatut:\n\t\t\t\t\t\t\t\t\t"
                                                )
                                              ]
                                            ),
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t\t" +
                                                _vm._s(fab.status) +
                                                "\n\t\t\t\t\t\t\t\t"
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-flex",
                                          {
                                            staticClass: "pl-3",
                                            attrs: { shrink: "" }
                                          },
                                          [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t\t" +
                                                _vm._s(
                                                  fab.unite_prestation.count ||
                                                    0
                                                ) +
                                                "\n\t\t\t\t\t\t\t\t\t" +
                                                _vm._s(
                                                  fab.unite_prestation.unit
                                                ) +
                                                "\n\t\t\t\t\t\t\t\t"
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-layout",
                                      { staticClass: "offset-right" },
                                      [
                                        _c(
                                          "v-flex",
                                          { attrs: { shrink: "" } },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "background--text text--lighten-5"
                                              },
                                              [
                                                _vm._v(
                                                  "\n\t\t\t\t\t\t\t\t\t\tFait le:\n\t\t\t\t\t\t\t\t\t"
                                                )
                                              ]
                                            ),
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t\t" +
                                                _vm._s(
                                                  _vm._f("formatDateNoTime")(
                                                    fab.end_date
                                                  )
                                                ) +
                                                "\n\t\t\t\t\t\t\t\t"
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-flex",
                                          {
                                            staticClass: "pl-3",
                                            attrs: { shrink: "" }
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "background--text text--lighten-5"
                                              },
                                              [
                                                _vm._v(
                                                  "\n\t\t\t\t\t\t\t\t\t\tpar:\n\t\t\t\t\t\t\t\t\t"
                                                )
                                              ]
                                            ),
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t\t" +
                                                _vm._s(fab.user.login) +
                                                "\n\t\t\t\t\t\t\t\t\t"
                                            ),
                                            _c(
                                              "span",
                                              { staticClass: "caption" },
                                              [
                                                _vm._v(
                                                  "\n\t\t\t\t\t\t\t\t\t\t" +
                                                    _vm._s(
                                                      _vm._f("capitalize")(
                                                        fab.user.name
                                                      )
                                                    ) +
                                                    "\n\t\t\t\t\t\t\t\t\t"
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("v-spacer"),
                                        _vm._v(" "),
                                        _c(
                                          "v-flex",
                                          { attrs: { shrink: "" } },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "background--text text--lighten-5"
                                              },
                                              [
                                                _vm._v(
                                                  "\n\t\t\t\t\t\t\t\t\t\tTemps passé:\n\t\t\t\t\t\t\t\t\t"
                                                )
                                              ]
                                            ),
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t\t" +
                                                _vm._s(
                                                  _vm._f("formatDateDuration")(
                                                    fab.spent_time
                                                  )
                                                ) +
                                                "\n\t\t\t\t\t\t\t\t"
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          })
                        ],
                        2
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-17ad53b2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17ad53b2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./build/scramble/app-loader.js!./src/pages/tools/suifa_of/suifa_of.vue
// module id = null
// module chunks = 